import classNames from 'classnames';
import { FieldProps, useFormikContext } from 'formik';
import { useCallback } from 'react';
import UDFormFieldWrapper from '../../wrapper';
import { UDFormComponentProps } from '../types';
import UDTimeInput, { UDTimeInputProps } from './component/time';

export type UDFormTimeInputProps = UDFormComponentProps & Omit<UDTimeInputProps, 'hasError' | 'valid' | 'onChange'>;

const UDFormTimeInput = (props: UDFormTimeInputProps) => {
  const { name, label, labelProps, containerProps, required, ...otherProps } = props;
  const { setFieldValue } = useFormikContext();
  const onChange = useCallback(
    (date: Date | null) => {
      setFieldValue(name, date);
    },
    [name, setFieldValue],
  );
  return (
    <UDFormFieldWrapper name={name} containerProps={containerProps} label={label} labelProps={labelProps} required={required}>
      {({ field, meta }: FieldProps<any>) => {
        return (
          <UDTimeInput
            {...field}
            className={classNames('w-full', otherProps?.className)}
            onChange={onChange}
            hasError={!!meta.error}
            valid={!meta.error && meta.touched && meta.value}
            {...otherProps}
          />
        );
      }}
    </UDFormFieldWrapper>
  );
};

export default UDFormTimeInput;
